import { useSelector } from 'react-redux';
import { getCurrentObjectTypeId } from '../../rewrite/init/selectors/routerStateSelectors';
export const useSelectedObjectTypeId = () => useSelector(getCurrentObjectTypeId);